import { connect } from 'react-redux';
import {
  setLoading,
  setLoadingProgress,
  setInitialized,
  addUnityCommand,
} from '../actions/unity';
import { updateSketcher, clearGraphics } from '../actions/engineering';
import { finishSimulation } from '../actions/simulation';
import UnityComponent from '../components/Unity/Unity';

const mapStateToProps = (state) => {
  return {
    webPath: state.unity.webglPath,
    mode: state.unity.mode,
    initialized: state.unity.initialized,
    unityContextInitialized: state.unity.unityContextInitialized,
    unityIsLoading: state.unity.loading,
  };
};

const mapDispatchToProps = {
  setInitialized,
  setLoading,
  setLoadingProgress,
  addUnityCommand,
  updateSketcher,
  clearGraphics,
  finishSimulation,
};

const Unity = connect(mapStateToProps, mapDispatchToProps)(UnityComponent);

export default Unity;
